"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDownPaymentFaceAmount = void 0;
const factor_calculator_1 = require("../factor-calculator");
function calculateDownPaymentFaceAmount(downPaymentAmount, factor) {
    if (!downPaymentAmount) {
        return 0;
    }
    if (!factor) {
        return downPaymentAmount;
    }
    return factor_calculator_1.multiplyByFactor(downPaymentAmount, factor);
}
exports.calculateDownPaymentFaceAmount = calculateDownPaymentFaceAmount;
//# sourceMappingURL=down-payment-calculator.js.map